var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3601 30.5928C7.84498 32.067 1.25042 35.0772 5.26696 38.844C7.229 40.684 9.4142 41.9999 12.1615 41.9999H27.8384C30.5858 41.9999 32.771 40.684 34.733 38.844C38.7496 35.0772 32.155 32.067 29.6398 30.5928C23.7418 27.1358 16.2581 27.1358 10.3601 30.5928Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 18.4183 24.4182 22 20 22C15.5817 22 12 18.4183 12 14C12 9.58172 15.5817 6 20 6C24.4182 6 28 9.58172 28 14Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0366 6.8665L40.0924 8.99572C40.2364 9.29212 40.6204 9.57643 40.9444 9.63087L42.8582 9.95146C44.082 10.1571 44.37 11.0524 43.488 11.9355L42.0002 13.4356C41.7482 13.6897 41.6102 14.1796 41.6882 14.5305L42.1142 16.3875C42.4502 17.8574 41.6762 18.426 40.3864 17.6578L38.5926 16.5871C38.2686 16.3935 37.7348 16.3935 37.4048 16.5871L35.611 17.6578C34.3272 18.426 33.5472 17.8513 33.8832 16.3875L34.3092 14.5305C34.387 14.1796 34.2492 13.6897 33.9972 13.4356L32.5094 11.9355C31.6334 11.0524 31.9154 10.1571 33.1392 9.95146L35.053 9.63087C35.371 9.57643 35.755 9.29212 35.899 8.99572L36.9548 6.8665C37.5308 5.71117 38.4666 5.71117 39.0366 6.8665Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperApply);
export default __webpack_public_path__ + "static/media/super-apply.7355a80baf7f2ae95db70234ea04de28.svg";
export { ForwardRef as ReactComponent };